// Captures campaign attribution params (utm_* + gclid) from the landing URL
// into sessionStorage so they survive route changes and the signup flow before
// LogRocket.identify / the backend save-signup-info call fires.

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const
const GCLID_KEY = 'gclid'
const SESSION_KEY = 'tc_utm_attribution'

type Attribution = Partial<Record<(typeof UTM_KEYS)[number] | typeof GCLID_KEY, string>>

export const captureAttribution = (): void => {
  try {
    const params = new URLSearchParams(window.location.search)
    const captured: Attribution = {}
    for (const key of UTM_KEYS) {
      const value = params.get(key)
      if (value) captured[key] = value
    }
    const gclid = params.get(GCLID_KEY)
    if (gclid) captured.gclid = gclid
    if (Object.keys(captured).length > 0) {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(captured))
    }
  } catch {
    // ignore (storage disabled / private mode)
  }
}

export const getAttribution = (): Attribution => {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

export const getGclid = (): string | undefined => getAttribution().gclid
